import { ConfiguracionFormattDate } from 'api/configuraciones/ConfigModelFormatters';
import moment from 'moment';
import CRUDgeneric from 'utils/CRUDgeneric';
import { formatReceived } from 'utils/formatValues';

export const URIdireccionGeneral = '/estructura-organizacional/empleados-domicilios-general/';
const _cliente = CRUDgeneric(URIdireccionGeneral);
const _nameModel = 'Dirección General';
const _nameModelSingular = 'la Dirección General';

const _formatRecordForRead = (record) => {
  const recordRequest = {
    ...formatReceived(record),
    // Convierte la fecha de vigencia final a objeto moment si existe, si no null
    vigencia_final: record?.vigencia_final
      ? moment(record?.vigencia_final)
      : null,
    empleado: record?.empleado?.id,
    tipo_de_direccion: record?.tipo_de_direccion?.id,

  };
  return recordRequest;
};
const _formatRecordForSend = (record) => {
  const recorResponse = ConfiguracionFormattDate(record);
  return recorResponse;
};
/**
 * GET DireccionGeneral
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getDireccionGeneral = async (params) => (
  _cliente.obtenerListaDeRegistros(params)
);
// Empaqueto todo en un objeto
/** permite llamarlo facilmente por el editor */
export const ModelDireccionGeneral = {
  cliente: _cliente,
  nameModel: _nameModel,
  nameModelSingular: _nameModelSingular,
  formatter: { // el actor que formatea.
    formatRecordForRead: _formatRecordForRead,
    formatRecordForSend: _formatRecordForSend,
  },
};
